module.exports = __webpack_public_path__ + "img/confetti-coleslaw.0dd0e925.jpg";